import getCachedEUEmailPolicyOptInBit from './getCachedEUEmailPolicyOptInBit';
import type NativeAdUserFlight from './NativeAdUserFlight';
import { emailadsOptInStore } from 'owa-emailadsoptin-store';
import { getNativeFinalFlightForUser } from './getNativeAdProperties';
import { isEUEmailAdsPolicyMarket } from 'mini-mail-aduser-log';

export function getNativeAdShowStatus(): NativeAdUserFlight {
    const staticNativeAdFlight = getNativeFinalFlightForUser();

    if (staticNativeAdFlight === 0) {
        return 0;
    }

    if (isEUEmailAdsPolicyMarket()) {
        if (emailadsOptInStore.emailAdsOptInBit === 2) {
            return 1;
        } else if (
            emailadsOptInStore.emailAdsOptInBit === -1 &&
            getCachedEUEmailPolicyOptInBit() === 2
        ) {
            return 1;
        } else {
            return 2;
        }
    }

    return staticNativeAdFlight;
}
